<template>
  <v-container grid-list-xl>
    <v-dialog v-model="showModal" max-width="90%">
      <UtilityAddressFinder
        v-if="newCustomer"
        :addressList="addresses"
        add="true"
        @close="setNewAddress"
      ></UtilityAddressFinder>
      <customer-address v-else add="true" @close="setNewAddress"></customer-address>
    </v-dialog>
    <v-dialog v-model="showContact" max-width="90%">
      <contact-modal v-if="showContact" v-on:closeContact="contactClosed" :contact="contact"></contact-modal>
    </v-dialog>

    <v-title>Addresses</v-title>

    <v-flex v-if="hasCurrentAddress" sm12 md12 lg12>
      <v-text-field
        label="Current Address:"
        name="currentSiteAddress"
        v-validate="'required'"
        prepend-icon="place"
        :disabled="inactive"
        readonly
        box
        v-model="details.currentSiteAddress"
        :error-messages="errors.collect('currentSiteAddress')"
      />
    </v-flex>

    <v-card>
      <v-layout justify-start v-bind="binding">
        <v-flex>
          <v-card>
            <v-card-title>
              <h3>New Address</h3>
              <!-- <v-checkbox v-model="checkbox2" label="Use the same address for postal?"></v-checkbox> -->
            </v-card-title>
            <v-layout justify-start row>
              <v-flex>
                <v-radio-group
                  v-model="details.newSiteAddress"
                  column
                  :disabled="inactive"
                  v-validate="'required'"
                  name="newSiteAddress"
                  data-vv-as="New Site Address"
                  :error-messages="errors.collect('newSiteAddress')"
                  @change="setPostalAddress"
                >
                  <v-radio
                    v-for="(address, index) in newSiteAddressList"
                    :key="index"
                    :label="address.formattedAddress"
                    :value="address.formattedAddress"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-btn
                v-on:click="showModal = true"
                :disabled="inactive"
                color="primary"
                large
              >Add Address</v-btn>
              <v-checkbox v-model="disablePostal" label="Set postal to same" :disabled="inactive"></v-checkbox>
            </v-card-actions>
          </v-card>
        </v-flex>

        <v-flex>
          <v-card>
            <v-card-title>
              <h3>Postal Address</h3>
              <!-- <v-checkbox v-model="checkbox2" label="Use the same address for postal?"></v-checkbox> -->
            </v-card-title>
            <v-layout justify-start row>
              <v-flex>
                <v-radio-group
                  v-model="details.postalAddress"
                  column
                  :disabled="inactive || disablePostal"
                  :error-messages="errors.collect('postalAddress')"
                  v-validate="'required'"
                  data-vv-as="Postal Address"
                  name="postalAddress"
                >
                  <v-radio
                    v-for="(address, index) in addresses"
                    :key="index"
                    :label="address.formattedAddress"
                    :value="address.formattedAddress"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
            </v-layout>
            <v-card-actions>
              <v-btn
                :disabled="inactive || disablePostal"
                v-on:click="showModal = true"
                color="primary"
                large
              >Add Address</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapActions: mapUtilityActions } = createNamespacedHelpers(
  `orders/utility`
);
import UtilityAddress from "@/components/utility/utility-address";
import UtilityAddressFinder from "@/components/utility/utility-address-finder";
const { mapActions: mapAddressActions } = createNamespacedHelpers(
  `orders/address`
);

export default {
  name: "UtilityAddressChangeDetails",
  inject: {
    $validator: "$validator"
  },
  props: {
    inactive: Boolean,
    details: Object,
    customerID: Number,
    hasCurrentAddress: Boolean,
    newCustomer: Boolean
  },
  components: {
    UtilityAddress,
    UtilityAddressFinder
  },
  data() {
    return {
      addresses: [],
      showModal: false,
      showContact: false,
      disablePostal: false
    };
  },
  watch: {
    disablePostal(val) {
      let vm = this;
      if (val) vm.details.postalAddress = vm.details.newSiteAddress;
      else vm.details.postalAddress = null;
    }
  },

  computed: {
    newSiteAddressList() {
      let vm = this;
      if (vm.newCustomer) return vm.addresses;
      else
        return vm.addresses.filter(
          x => !(x.formattedAddress == vm.details.currentSiteAddress)
        );
    },
    binding() {
      const binding = {};
      if (this.$vuetify.breakpoint.mdAndUp) {
        binding.row = true;
      } else {
        binding.column = true;
      }
      return binding;
    }
  },
  created() {
    let vm = this;
    vm.$nextTick(() => {
      if (!vm.newCustomer) {
        let collectedAddresses;
        collectedAddresses = vm.getCustomerAddresses();
        collectedAddresses.then(result => {
          if (result) {
            vm.addresses = result;

            if (
              vm.details.newSiteAddress &&
              vm.details.newSiteAddress === vm.details.postalAddress
            )
              vm.disablePostal = true;
          }
        });
      } else {
        if (vm.details.newSiteAddress) {
          vm.addresses.push({
            formattedAddress: vm.details.newSiteAddress
          });
        }
        if (
          vm.details.postalAddress &&
          vm.details.postalAddress !== vm.details.newSiteAddress
        ) {
          vm.addresses.push({
            formattedAddress: vm.details.postalAddress
          });
        }

        if (
          vm.details.newSiteAddress &&
          vm.details.newSiteAddress === vm.details.postalAddress
        )
          vm.disablePostal = true;
      }
    });
  },
  methods: {
    ...mapUtilityActions(["getCustomerAddresses", "addAddress"]),
    ...mapAddressActions(["getAllAddresses", "addAddress"]),
    togglePostalAsSame() {
      let vm = this;
      if (vm.showPostal) {
        vm.showPostal = false;
      } else {
        vm.details.postalAddress = null;
        vm.showPostal = true;
      }
    },
    setPostalAddress() {
      let vm = this;
      if (vm.disablePostal)
        vm.details.postalAddress = vm.details.newSiteAddress;
    },
    setNewAddress(val) {
      let vm = this;
      // if (val) {
      vm.details.newSiteAddress =
        vm.addresses[vm.addresses.length - 1].formattedAddress;
      if (vm.disablePostal)
        vm.details.postalAddress = vm.details.newSiteAddress;
      // }
      vm.showModal = false;
    }
  }
};
</script>

<style>
</style>
